import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { PrimengModule } from '../shared/primeng.module';
import { IconsModule } from '../shared/icons.module';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { AdminComponent } from './admin.component';
import { AdminHeaderComponent } from './admin-header/admin-header.component';
import { UsersComponent } from './users/users.component';
import { GroupsComponent } from './groups/groups.component';
import { ThemeComponent } from './theme/theme.component';
import { GroupCardComponent } from './groups/group-card/group-card.component';
import { TimelinesComponent } from './timelines/timelines.component';
import { MessageService } from 'primeng/api';
import { OutcomesComponent } from './outcomes/outcomes.component';
import { WpApprovalComponent } from './wp-approval/wp-approval.component';
import { WpComponent } from './wp-approval/wp/wp.component';
import { SharedModule } from '../shared/shared.module';
import { UploadComponent } from './outcomes/upload/upload.component';
import { SyncComponent } from './outcomes/sync/sync.component';
import { NoDataFoundComponent } from "../shared/no-data-found/no-data-found.component";
import { AdminUsersModelComponent } from './users/admin-users-model/admin-users-model.component';


@NgModule({
  declarations: [
    AdminComponent,
    AdminHeaderComponent,
    UsersComponent,
    GroupsComponent,
    ThemeComponent,
    GroupCardComponent,
    TimelinesComponent,
    OutcomesComponent,
    WpApprovalComponent,
    WpComponent,
    UploadComponent,
    SyncComponent,
    AdminUsersModelComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimengModule, IconsModule, NgbPopoverModule, SharedModule, NoDataFoundComponent],
  providers:[MessageService]
})
export class AdminModule {}
